<template>
    <v-card flat color="grey-f1" rounded="lg" class="py-16 px-24">
        <p class="page--text text-center mb-10">
            <span> 최종 매칭된 지원자의 연락처는 인터뷰 데이 시작일에 기업에게 공개됩니다. </span> <br />
            <span> 온라인 인터뷰를 선택하시면, 마이스펙에서제공하는 비대면인터뷰 기능을 이용할 수 있습니다. </span>
        </p>
        <p class="page--text text-center">
            <span> 인터뷰 시간에 맞춰 '온라인 인터뷰' 버튼을 클릭해 주세요. </span> <br />
            <span> 인터뷰 신청 후 기업의 승인이 완료되면, 매칭 정보에 '매칭 완료'로 표시됩니다. </span> <br />
            <span> 매칭 기간 종료 후, 인터뷰 기간에 인터뷰가 진행됩니다. </span>
        </p>
    </v-card>
</template>

<script>
export default {};
</script>

<style>
</style>